module.exports = __webpack_public_path__ + "media/images/about/team-1d930caff1cc8406d49add705284571e.jpg";